import React, { useState } from 'react';
import { Spinner } from 'reactstrap';
import OperationalKanban from './components/OperationalKanban';
import OperationalItemSidebar from './components/OperationalItemSidebar';
import CreateTaskSidebar from './components/CreateTaskSidebar';
import useOperationalMetrics from './hooks/useOperationalMetrics';

const OperationalDashboard = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [createSidebarOpen, setCreateSidebarOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const { mySalesTodayCount, mySalesTodayTotal, loading: loadingMetrics } = useOperationalMetrics();

    const handleItemClick = (item) => {
        setSelectedItem(item);
        setSidebarOpen(true);
    };

    const handleTaskCreated = () => {
        setRefreshKey(prev => prev + 1);
    };

    const formatCurrency = (val) => {
        return (val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <React.Fragment>
            <div className="d-flex justify-content-end align-items-center pt-2 mb-4">
                <div className="bg-white border rounded-3 px-4 py-2 d-flex align-items-center shadow-sm">
                    <div className="me-4">
                        <p className="text-uppercase font-size-11 fw-bold text-muted mb-0 letter-spacing-1">Minhas Vendas (Hoje)</p>
                        <div className="d-flex align-items-baseline gap-2 mt-1">
                            {loadingMetrics ? (
                                <Spinner size="sm" color="primary" />
                            ) : (
                                <>
                                    <h4 className="mb-0 fw-bold text-dark">{String(mySalesTodayCount).padStart(2, '0')}</h4>
                                    <span className="text-muted mx-1">|</span>
                                    <h4 className="mb-0 fw-bold text-primary">{formatCurrency(mySalesTodayTotal)}</h4>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px' }}>
                        <i className="mdi mdi-shopping-outline font-size-22"></i>
                    </div>
                </div>
            </div>

            <OperationalKanban 
                refreshKey={refreshKey}
                onItemClick={handleItemClick} 
                onNewTaskClick={() => setCreateSidebarOpen(true)}
            />

            <OperationalItemSidebar 
                isOpen={sidebarOpen} 
                toggle={() => setSidebarOpen(!sidebarOpen)} 
                item={selectedItem} 
            />

            <CreateTaskSidebar
                isOpen={createSidebarOpen}
                toggle={() => setCreateSidebarOpen(!createSidebarOpen)}
                onTaskCreated={handleTaskCreated}
            />
        </React.Fragment>
    );
};

export default OperationalDashboard;
